// Removes 'PER' from the gender array and puts 'M' and 'F' in place
export default function formatGenderArray(array: string[]): string[] {
  const arrayAux = [...array];
  const index = arrayAux.indexOf('PER');
  if (index >= 0) arrayAux.splice(index, 1, 'M', 'F');
  return arrayAux;
}
